import React from "react";
import "./LoadingStyle.css";

const Loading = ({ 
  variant = "modern", 
  text = "Loading...", 
  size = "large", 
  layout = "fullscreen", // fullscreen, inline, card
  className = "",
  showBrand = true 
}) => {
  const renderSpinner = () => {
    switch (variant) {
      case "pulse":
        return (
          <div className="modern-loading-pulse">
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
            <div className="pulse-center"></div>
          </div>
        );
      
      case "dots":
        return (
          <div className="modern-loading-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        );
      
      case "bars":
        return (
          <div className="modern-loading-bars">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        );
      
      case "gradient":
        return (
          <div className="modern-loading-gradient">
            <div className="gradient-circle"></div>
          </div>
        );
      
      default: // "modern" or "streak"
        return (
          <div className="modern-loading-spinner">
            <div className="modern-tilted-streak"></div>
            <div className="modern-tilted-streak"></div>
            <div className="modern-tilted-streak"></div>
          </div>
        );
    }
  };

  const getContainerClasses = () => {
    const baseClasses = "modern-loading-container d-flex align-items-center justify-content-center";
    
    switch (layout) {
      case "inline":
        return `${baseClasses} loading-inline ${className}`;
      case "card":
        return `${baseClasses} loading-card ${className}`;
      default: // fullscreen
        return `${baseClasses} position-fixed w-100 h-100 loading-overlay ${className}`;
    }
  };

  return (
    <div className={getContainerClasses()}>
      {layout === "fullscreen" && <div className="loading-backdrop position-absolute w-100 h-100"></div>}
      <div className="modern-loading-content d-flex flex-column align-items-center position-relative">
        <div className={`loading-spinner-wrapper ${size}`}>
          {renderSpinner()}
        </div>
        {text && (
          <div className="loading-text mt-4 text-center">
            <p className="mb-2 fw-medium">{text}</p>
            {layout === "fullscreen" && (
              <div className="loading-progress">
                <div className="progress-bar"></div>
              </div>
            )}
          </div>
        )}
        {showBrand && layout === "fullscreen" && (
          <div className="brand-logo mt-3">
            <span className="brand-text fw-bold">Kaphy Insurance Agency</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loading;
